"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockRouterData = void 0;
const faker_1 = require("@faker-js/faker");
const lodash_1 = require("lodash");
function mockRouterData(overwrites) {
    const pathname = faker_1.faker.random.word() + '/' + faker_1.faker.random.word();
    return Object.assign({ asPath: pathname +
            '?' +
            Object.entries((overwrites === null || overwrites === void 0 ? void 0 : overwrites.query) || {})
                .map(([key, value]) => `${key}=${value}`)
                .join('&'), pathname: '', query: {}, updateQuery: lodash_1.noop, push: lodash_1.noop }, overwrites);
}
exports.mockRouterData = mockRouterData;
//# sourceMappingURL=Router.factory.js.map